const styles = theme => ({
    wrapper: {
        marginBottom: theme.spacing(2)
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    fatigueCaption: {
        color: theme.palette.text.primary,
        fontWeight: 600,
    }
});

export default styles;